const ID_CSS_KEY = "css";
export const getCss = () => {
  return window.localStorage.getItem(ID_CSS_KEY);
};
export const saveCss = css => {
  window.localStorage.setItem(ID_CSS_KEY, css);
};
export const destroyCss = () => {
  window.localStorage.removeItem(ID_CSS_KEY);
};

export default { getCss, saveCss, destroyCss };